import { render, staticRenderFns } from "./Rumcs.vue?vue&type=template&id=66ee79b5&"
import script from "./Rumcs.vue?vue&type=script&lang=js&"
export * from "./Rumcs.vue?vue&type=script&lang=js&"
import style0 from "./Rumcs.vue?vue&type=style&index=0&id=66ee79b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports